import { render, staticRenderFns } from "./ParentCategoryCreate.vue?vue&type=template&id=c2e012ee&scoped=true"
import script from "./ParentCategoryCreate.vue?vue&type=script&lang=js"
export * from "./ParentCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e012ee",
  null
  
)

export default component.exports